import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { SpinLoader } from "deltoid/core/Loaders";
import { toastActions, dialogActions, dialogSelectors, manualUploadActions } from "@store/ducks";

const UploadedFile = ({
  file,
  path,
  fileName,
  documentCategoryId,
  documentTypeId,
  uploadFile,
  removeFile,
  onFileRemove,
  addFilePathAndIDItem,
  removeFilePathAndIDItem,
  setDocUUID,
  showToast,
}) => {
  const [name, setFileName] = useState(fileName);
  const [uploadStatus, setUploadStatus] = useState("initial");
  const [fileUUID, setFileUUID] = useState(null);
  const [fileID, setFileID] = useState(null);

  useEffect(() => {
    handleFileUpload();
  }, []);

  const handleFileUpload = () => {
    let fileData = new FormData();
    fileData.append("uploaded_documents", file);
    fileData.append("document_category_id", documentCategoryId);
    fileData.append("document_type_id", documentTypeId);
    setUploadStatus("uploading");

    uploadFile(fileData, (attachment) => {
      if (attachment) {
        setUploadStatus("uploaded");
        setDocUUID(attachment.kyc_document_uuid);
        setFileUUID(attachment.kyc_document_uuid);
        setFileID(attachment.id);
        addFilePathAndIDItem({ path: path, id: attachment.id });
      } else {
        showToast(
          "warning",
          "Warning",
          `We encountered an error. Could not upload ${fileData.name}. Please select and try uploading again`
        );
        onFileRemove(path);
        setUploadStatus("uploadError");
      }
    });
  };

  const removeAttachment = () => {
    if (fileUUID) {
      const fileData = [fileID];
      removeFile(fileData, (response) => {
        setUploadStatus("uploading");
        onFileRemove(path);
        removeFilePathAndIDItem(path);
        showToast("success", "Success", `${fileName} was removed successfully.`);
      });
    }
  };

  return (
    <div className="box-uploaded-file">
      <div className="status-icon-wrap">
        {uploadStatus === "initial" && <UploadIcon />}
        {uploadStatus === "uploading" && <SpinLoader size='16px' />}
        {uploadStatus === "uploaded" && <SuccessIcon />}
        {uploadStatus === "uploadError" && <ErrorIcon />}
      </div>
      <div className="file-name-box">{name}</div>
      <div className="remove-icon-wrap" onClick={removeAttachment}>
        <CrossIcon width="12px" height="12px" />
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  uploadFile: (fileData, callback) => dispatch(manualUploadActions.appendAttachment(fileData, callback)),
  removeFile: (fileData, callback) => dispatch(manualUploadActions.removeAttachment(fileData, callback)),
  addFilePathAndIDItem: (filePathAndIDItem) => dispatch(manualUploadActions.addFilePathAndIDItem(filePathAndIDItem)),
  removeFilePathAndIDItem: (path) => dispatch(manualUploadActions.removeFilePathAndIDItem(path)),
  showToast: (variant, title, content) =>
    dispatch(toastActions.show({ variant: variant, title: title, content: content })),
});

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UploadedFile);

const UploadIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" transform="translate(-6 -6)" />
        <g fill="#808080" fillRule="nonzero">
          <path
            d="M8.907 3.128l-2.625-3C6.211.048 6.108 0 6 0c-.108 0-.21.047-.282.128l-2.625 3c-.097.111-.12.268-.06.402.062.134.195.22.342.22h1.5v4.875c0 .207.168.375.375.375h1.5c.207 0 .375-.168.375-.375V3.75h1.5c.147 0 .28-.086.341-.22s.039-.291-.059-.402z"
            transform="translate(-6 -6) translate(6 6)"
          />
          <path
            d="M10.4 8v2.4H1.6V8H0v3.2c0 .442.358.8.8.8h10.4c.442 0 .8-.358.8-.8V8h-1.6z"
            transform="translate(-6 -6) translate(6 6)"
          />
        </g>
      </g>
    </svg>
  );
};

const ErrorIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.79394C0 13.2119 3.566 16.7939 8 16.7939C12.433 16.7939 15.999 13.2119 15.999 8.79394C15.999 4.37594 12.433 0.793945 7.999 0.793945C3.567 0.794945 0 4.37695 0 8.79495V8.79394ZM8 3.79395C7.518 3.79395 7.036 4.24795 7.036 4.79395L7.229 9.29495C7.229 9.71395 7.615 10.0449 8 10.0449C8.482 10.0449 8.771 9.71395 8.771 9.29495L8.964 4.79395C8.964 4.24795 8.579 3.79395 8 3.79395ZM6.843 12.4199C6.843 11.7999 7.421 11.2959 7.999 11.2959C8.577 11.2959 9.156 11.7999 9.156 12.4199C9.156 13.0419 8.577 13.5459 7.999 13.5459C7.421 13.5459 6.843 13.0419 6.843 12.4199Z"
        fill="#E92F00"
      />
    </svg>
  );
};

const SuccessIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="28.5814" height="28.5814" rx="14.2907" fill="#18AF8B" stroke="#18AF8B" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7167 11.19C21.0778 11.447 21.0778 11.8687 20.807 12.1322L13.4057 18.7995C13.3154 18.9336 13.1349 19.0067 12.8641 18.9995C12.6836 18.9931 12.5031 18.9079 12.3226 18.7642L9.1635 15.4309C8.89272 15.1498 8.98298 14.7289 9.25375 14.4912C9.61479 14.2534 10.0661 14.2879 10.3369 14.5691L12.9544 17.3433L19.7239 11.2004C19.9946 10.9378 20.4459 10.9322 20.7167 11.19Z"
        fill="white"
      />
    </svg>
  );
};

const CrossIcon = ({ width, height }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8194 1.13739C12.0602 0.877324 12.0602 0.455117 11.8194 0.19505C11.4983 -0.0650167 11.097 -0.0650167 10.8562 0.19505L5.95987 5.05365L1.14381 0.19505C0.822742 -0.0650167 0.421405 -0.0650167 0.180602 0.19505C-0.0602007 0.455117 -0.0602007 0.877324 0.180602 1.13739L5.07692 5.99599L0.180602 10.8554C-0.0602007 11.1155 -0.0602007 11.5369 0.180602 11.7969C0.421405 12.0578 0.822742 12.0578 1.14381 11.7969L5.95987 6.93833L10.8562 11.7969C11.097 12.0578 11.4983 12.0578 11.8194 11.7969C12.0602 11.5369 12.0602 11.1155 11.8194 10.8554L6.92308 5.99599L11.8194 1.13739Z"
        fill="#3B3F46"
      />
    </svg>
  );
};
